import { render } from "./MainLayoutAfterlogin.vue?vue&type=template&id=4e123872&scoped=true"
import script from "./MainLayoutAfterlogin.vue?vue&type=script&lang=js"
export * from "./MainLayoutAfterlogin.vue?vue&type=script&lang=js"

import "./MainLayoutAfterlogin.vue?vue&type=style&index=0&id=4e123872&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e123872"]])

export default __exports__